import { fetchWrapperPublic } from "helpers/fetch-wrapper";
import { API_BASE_URL } from "helpers/constants";

export class StatisticsQueries {
    static async getAllStats(timeframe?: string): Promise<Response> {
        const query = timeframe ? `?timeframe=${timeframe}` : '';
        return await fetchWrapperPublic.get(`${API_BASE_URL}/data/stats/best-selling${query}`);
    }

    static async getAdvancedStats(): Promise<Response> {
        return await fetchWrapperPublic.get(`${API_BASE_URL}/data/stats/advanced`);
    }

    static async getPredictiveStats(): Promise<Response> {
        return await fetchWrapperPublic.get(`${API_BASE_URL}/data/stats/predictive`);
    }
}